import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';

export function amisDataReceivedReducer(sectionState: boolean = false, action: AnyAction): boolean {
  switch (action.type) {
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      return true;
    }
    default:
      return sectionState;
  }
}
